import type { ApiKeyScope } from '@/services/apiKeys'
import { API_KEY_SCOPE_PILL_LABELS } from './constants'

export const scopeLabel = (scope: ApiKeyScope): string =>
  API_KEY_SCOPE_PILL_LABELS[scope] ?? scope

/** 150000 → '150 000' (thin-space groups, per design). */
export const formatCount = (n: number): string =>
  n.toLocaleString('en-US').replace(/,/g, ' ')

export const formatPercent = (percent: number): string => {
  if (percent === 0) {
    return '0%'
  }

  if (percent < 0.01) {
    return '<0.01%'
  }

  const digits = percent < 1 ? 2 : percent < 10 ? 1 : 0

  return `${percent.toFixed(digits)}%`
}

/** '2026-04-09' → '9 Apr'; the year is shown only when it isn't the current one. */
export const formatDate = (iso?: string | null): string => {
  if (!iso) {
    return '—'
  }

  const date = new Date(iso)

  if (Number.isNaN(date.getTime())) {
    return '—'
  }

  const day = `${date.getDate()} ${date.toLocaleDateString('en-US', {
    month: 'short',
  })}`

  return date.getFullYear() === new Date().getFullYear()
    ? day
    : `${day}, ${date.getFullYear()}`
}
